"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'network';
exports.SET_INTERNET_CONNECTED = exports.namespace + "/SET_INTERNET_CONNECTED";
exports.SET_INTERNET_SOURCE = exports.namespace + "/SET_INTERNET_SOURCE";
//# sourceMappingURL=constants.js.map